"use client";

import React from "react";

export const TranslationsContext = React.createContext<Record<string, string> | null>(null);
